import React, { useState, useContext } from "react";
import { GreenMachineContext } from "../GreenMachineContext";
import SelectSessionList from "./SelectSessionList";
import "./SelectSessionPage.css";

export default function SelectSessionPage() {
  const { currentStage, STAGE_NUMBERS } = useContext(GreenMachineContext);

  if (currentStage !== STAGE_NUMBERS.selectSession) {
    return null;
  }

  return (
    <div className="gm-select-session-page-container">
      <React.Suspense fallback="Loading sessions...">
        <SelectSessionList />
      </React.Suspense>
    </div>
  );
}
